import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import OrganizationsView from 'components/organizations/OrganizationsView';
import BasePage from 'components/UI/BasePage';
import { setPaneContent } from 'services/pane/slice';
import links from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const OrganizationsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t('organizations')}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { label: t('organizations') },
          ]}
        />
        <h4>{t('organizations')}</h4>
        <OrganizationsView
          onOrganizationSelect={
            organizationId => dispatch(
              setPaneContent({
                type: 'ORGANIZATION',
                id: organizationId,
              })
            )
          }
        />
      </BasePage>
    </>
  );
};

export default OrganizationsPage;
